// The four canonical ownership hierarchies, in display order (Organisation leads — it's the
// primary accountability lens and drives the headline "unallocated" KPI).
//
// Their ids are resolved by CODE at runtime: budget_dimension ids are sequence-assigned and
// differ per environment, so hardcoding them mislabels columns and loads the wrong hierarchy
// in the owner picker. Codes also vary — short forms (org/fin/tech/uc), long forms
// (organisation/financial/technical/use_case), and the legacy fin_category — so every spec
// accepts all known aliases.
export const DIMENSION_SPECS = [
  { codes: ["organisation", "org"], name: "Organisation" },
  { codes: ["financial", "fin", "fin_category"], name: "Financial" },
  { codes: ["technical", "tech"], name: "Technical" },
  { codes: ["use_case", "uc"], name: "Use-case" },
];

// resolveDimensions maps the /api/v1/budget-dimensions response (BudgetDimension may serialize
// PascalCase ID/Code/Name) to the ordered [{ id, name }] columns, dropping any hierarchy whose
// code isn't present (and any non-canonical/stale dimension).
export const resolveDimensions = (dimensionsRaw) => {
  const dims = (dimensionsRaw ?? []).map((d) => ({
    id: d.id ?? d.ID,
    code: (d.code ?? d.Code ?? "").toLowerCase(),
  }));
  return DIMENSION_SPECS.map((spec) => {
    const found = dims.find((d) => spec.codes.includes(d.code));
    return found ? { id: found.id, name: spec.name } : null;
  }).filter(Boolean);
};

// orgDimensionId returns the resolved Organisation dimension id (the primary ownership lens).
export const orgDimensionId = (dimensions) =>
  (dimensions.find((d) => d.name === "Organisation") || {}).id;
